import React from "react";

import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

export default function TechDataCardBody(props) {
  return (
    <CardContent style={{ padding: "8px 16px" }}>
      <Box px={1}>
        <Box pb={1}>
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            pb={0.5}
            height={31}
          >
            <Typography
              variant='overline'
              style={{ fontSize: 10 }}
              className='line-clamp-1'
            >
              {props.subtitle}
            </Typography>
          </Box>
          <Box height={64} display='flex' alignItems='center'>
            <Typography variant='h6' className='line-clamp-3' gutterBottom>
              {props.title}
            </Typography>
          </Box>
        </Box>
        {/* <Box color={theme.palette.primary.light} height={105}>
          <Typography className='line-clamp'>{props.snippet}</Typography>
        </Box> */}
      </Box>
    </CardContent>
  );
}
